import React, { Component } from "react";

import {
  CButton,
  CInput,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader
} from "@coreui/react";
import { createPortal } from "react-dom";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import URL from "../../config/api";
import axios from "../../config/axios";

const appRoot = document.getElementById("root");

class PasswordModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: "",
      confirmPassword: ""
    };

    this.el = document.createElement("div");
  }

  componentDidMount() {
    appRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    appRoot.removeChild(this.el);
  }

  passwordEdit() {
    if (this.state.password.length < 8) {
      toastr.warning(
        "A senha precisa de pelo menos 8 caracteres",
        "Digite novamente"
      );
      return;
    }

    if (this.state.password !== this.state.confirmPassword) {
      toastr.warning("As senhas não são iguais", "Digite novamente");
      return;
    }

    axios
      .post(
        `${URL.api}access/user/update/${this.props.id}`,
        {
          id: this.props.id,
          password: this.state.password,
          last_login_at: "null"
        },
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        res => {
          if (res.data.success) {
            toastr.success("Sucesso", "A senha foi alterada");
            this.props.onClose();
          } else {
            toastr.error("Erro", "Tente novamente");
          }
        },
        () => {
          toastr.error("Erro", "Tente novamente");
        }
      );
  }

  render() {
    return createPortal(
      <CModal
        show={this.props.show}
        onClose={() => this.props.onClose()}
        centered
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>Editar senha</CModalHeader>
        <CModalBody>
          <form autoComplete="off">
            <CInput
              type="password"
              autoComplete="new-password"
              placeholder="Digite sua nova senha"
              className="mb-3"
              value={this.state.password}
              onChange={e => this.setState({ password: e.target.value })}
            />
            <CInput
              type="password"
              autoComplete="new-password"
              placeholder="Digite sua nova senha novamente"
              value={this.state.confirmPassword}
              onChange={e => this.setState({ confirmPassword: e.target.value })}
            />
          </form>
        </CModalBody>
        <CModalFooter>
          <CButton color="primary" onClick={() => this.passwordEdit()}>
            Salvar
          </CButton>
          <CButton color="secondary" onClick={() => this.props.onClose()}>
            Cancelar
          </CButton>
        </CModalFooter>
      </CModal>,
      this.el
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PasswordModal);
